import * as React from 'react';
import { styles } from './styles';

type Props = {
  refForward?: React.RefObject<HTMLDivElement>;
} & React.HTMLProps<HTMLDivElement>;

class AdminConsole extends React.Component<Props> {
  render() {
    const { className, refForward, ...rest } = this.props;
    return (
      <div ref={refForward} className={[className, styles.container].filter(c => c).join(' ')} {...rest}>
        {this.props.children}
      </div>
    );
  }
}

export { AdminConsole };
